module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"schedule":"Расписание","registration-on":"Регистрация на"},"en":{"schedule":"Schedule","registration-on":"Registration for the"}}')
  delete Component.options._Ctor
}
